<template>
    <div>
      <el-dialog title="回执信息" :visible.sync="dialogVisible" >
        <el-form label-position="right" label-width="150px" :rules="rules">
          <el-row>
            <el-col v-for="(item, index) in content.policy" :key="index">
              <el-form-item label="保单号">
                <el-input type="textarea" class="w-75" v-model="item.policy_number" :autosize="{miniRows: 5, maxRows: 20}"></el-input>
              </el-form-item>
              <el-form-item label="船舶名称">
                <el-input class="w-75" v-model="item.ship_name"></el-input>
              </el-form-item>
              <el-form-item label="投保人">
                <el-input class="w-75" v-model="item.applicant"></el-input>
              </el-form-item>
              <el-form-item label="被保险人">
                <el-input class="w-75" v-model="item.insured"></el-input>
                
              </el-form-item>
              <el-form-item label="专票/普票">
                <el-input class="w-75" v-model="item.invoice"></el-input>
              </el-form-item>
              <el-form-item label="油污证明">
                <el-input class="w-75" v-model="item.greasy_dirt"></el-input>
              </el-form-item>

              <el-divider></el-divider>
            </el-col>
            <el-col>
              <el-form-item label="非保险责任提示">
                <el-checkbox style="width: 30%" v-for="tip in tips_list" :label="tip" :key="tip.value" 
                          v-model="tip.is_check">
                  {{tip.name}}
                </el-checkbox>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="content.remark"></el-input>
              </el-form-item>
              <el-form-item label="签署日期">
                <el-date-picker
                  v-model="content.date"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="业务归属部门" prop="business_area">
                  <el-select v-model="content.business_area" placeholder="请选择部门" filterable value-key="id"  style="width: 48%;">
                  <el-option v-for="g in groupList" :key="g.id"
                      :label="g.name" :value="g.name"></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="border-top mt-2 pt-3">
              <el-form-item>
                <el-button size="small" type="primary" style="float: right" @click="handlePrint">打印</el-button>
                <el-button size="small" type="primary" style="float: right" @click="addPolicy">添加保单</el-button>
                <el-button size="small" type="primary" style="float: right" @click="deletePolicyData">删除保单</el-button >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <el-dialog title="添加保单" :visible.sync="addPolicyVisible" width="620px" top="20px">
      <el-form>
        <el-form-item label="保险单号">
          <el-select filterable v-model="select_policy_number" placeholder="选择批改保险单号" clearable value-key="id" 
          remote :remote-method="remoteCustomerMethod" :loading="policy_loading" style="width: 80%; ">
                    <el-option v-for="at in policy_numbers" :key="at.id" :label="at.policy_number + '' + '    相关船舶:' + at.ship_name"
                        :value="at" ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary" :loading="loading" size="small" @click="addPolicyData">确认添加</el-button>
    </el-dialog>
    <el-dialog title="删除保单" :visible.sync="deletePolicyVisible" width="620px" top="20px">
      <el-form>
        <el-form-item label="保险单号">
            <el-select placeholder="请选择保单" v-model="delete_policy_number" >
            <el-option v-for="s in policy" :key="s.id" :label="s.policy_number + '' + '    相关船舶:' + s.ship_name"
                       :value="s.policy_number"></el-option>
          </el-select>&nbsp;
        </el-form-item>
      </el-form>
      <el-button type="primary" :loading="loading" size="small" @click="deletePolicy">确认删除</el-button>
    </el-dialog>
    </div>
  </template>
  
  <script>
    import { getReceiptInfo,getPolicyNumber,getReceiptPolicyNumber } from '@/api/receipt'
    import { fetchList as fetchGroupList } from "@/api/group";
    import { updatePolicyReceipt } from '@/api/policy'

  
    export default {
      name: 'policy-receipt-dialog',
      props: {
        policy_list: {
            type: Array,
            required: true
        },
      },
      data() {
        return {
          dialogVisible: false,
          
          policy: [],
          groupList:[],
          policy_numbers:[],
          delete_policy_numbers:[],
          select_policy_number:null,
          delete_policy_number:null,
          policy_loading:false,
          addPolicyVisible:false,
          deletePolicyVisible:false,
          loading:false,
          query:{
            search:''
          },
          content: {
            policy: [],
            policy_id: [],
            date: '',
            remark: '',
            business_area:'',
          },
          tips_list: [
            {value: 1, name: "触碰桥梁", is_check: false},
            {value: 2, name: "民用建筑、市政设施、电缆管道", is_check: false},
            {value: 3, name: "渔网、养殖场", is_check: false},
            {value: 4, name: "第三者人身伤亡", is_check: false},
            {value: 5, name: "本船油污", is_check: false},
            {value: 6, name: "船员自身疾病导致的伤亡", is_check: false},
            {value: 7, name: "本船货物受损", is_check: false},
            {value: 8, name: "残骸清除", is_check: false}
          ],
          rules: {
            business_area: [
              {required: true, message: "请选择业务归属部门", trigger: "blur"}
            ],
          }
        }
      },
      methods: {
        deletePolicy(){
            this.policy = this.policy.filter(item => item.policy_number !== this.delete_policy_number)
            this.delete_policy_number = null
            this.deletePolicyVisible = false
            this.handleInfo()
        },
        deletePolicyData(){
            // getReceiptPolicyNumber({'id':this.select_row}).then(res => {
            //   this.delete_policy_numbers = res
            //   this.policy_loading = false
            // }).catch(err => {
            //   this.customer_loading = false
            //   this.$policy_loading(err)
            // })
            this.deletePolicyVisible = true
        },
        addPolicyData(){
          if (this.select_policy_number) {
            if (this.policy.find(item => {return item.policy_number === this.select_policy_number.policy_number})) {
              this.$message.error('该保单已添加')
              return
            }
            this.policy.push(this.select_policy_number)
            this.addPolicyVisible = false
            this.handleInfo()
          }
        },
        addPolicy(){
            this.addPolicyVisible = true
        },
        remoteCustomerMethod(query) {
        if (query !== '') {
          this.policy_loading = true
          setTimeout(() => {
            getPolicyNumber({'search': query}).then(res => {
              this.policy_numbers = res
              this.policy_loading = false
            }).catch(err => {
              this.customer_loading = false
              this.$policy_loading(err)
            })
          }, 200);
        } else {
          this.customers = [];
        }
      },
        handleReceiptPrint(select_row) {
          this.dialogVisible = true
          this.select_row = select_row
          getReceiptInfo({'id':select_row})
            .then(resp => {
            this.content = resp.content
            this.policy = resp.policy
            this.tips_list.forEach(item => {
              // 判断content.tips中的值是否与tips_list中的值相等且is_check为true
              if (this.content.tips.find(item2 => {
                return (item2.name === item.name && item2.is_check === true)
              })) {
                this.$set(item, 'is_check', true)
              } else {
                this.$set(item, 'is_check', false)
              }
            })
            })
            .catch(error => {
            this.$message.error(error)
            })
            
          this.handleInfo()
        },
        resetContent(){
            this.$set(this.content, 'policy', [])
            this.$set(this.content, 'policy_id', [])
            // this.$set(this.content, 'business_area', '')

        },

        handleInfo() {
           this.resetContent()
          let ship_obj = {}
          let shipname_list = []
          this.policy.forEach(element => {
            this.content.policy_id.push(element.id)
            if (shipname_list.indexOf(element.ship_name) == -1) {
              shipname_list.push(element.ship_name)
              ship_obj[element.ship_name] = {
                ship_name: element.ship_name,
                insured: element.insured,
                applicant: element.applicant,
                policy_number: element.policy_number + '（' + element.insurance_type + '）；',
                invoice: '',
                greasy_dirt: ''
              }
            } else {
              ship_obj[element.ship_name].policy_number += element.policy_number + '（' + element.insurance_type + '）；'
            }
          })
          Object.keys(ship_obj).forEach((key) => {
            this.content.policy.push(ship_obj[key])
          })
        },
        loadData() {
              let p = []
              p.push(fetchGroupList({type:"group_apply"}))
   
              Promise.all(p)
                  .then(res => {
   
                  this.groupList  =res[0]
  
                  })
                  .catch(error => {
                  this.loading = false
                  this.$message.error(error)
                  })
          },
        handlePrint() {
          if (!this.content.business_area) {
            this.$message.error('请选择业务部门')
            return
          }
          
  
          if (this.content.policy_id.length < 1) {
            this.$message.error('请选择保单')
            return
          }
          this.content.tips = this.tips_list
          this.content.receipt_id = this.select_row
          updatePolicyReceipt(this.content)
            .then(res => {
              let link = document.createElement('a')
              link.style.display = 'none'
  
              let blob = new Blob([res])
              link.href = URL.createObjectURL(blob)
  
              link.download = '保单送达书.pdf'
              document.body.appendChild(link)
  
              link.click()
              URL.revokeObjectURL(blob)
              document.body.removeChild(link)
  
              this.dialogVisible = false
              location.reload(true)
              this.$emit('update-list', [])
              this.$message.success("成功打印回执")
            })
            .catch(error => {
              this.$message.error(error)
            })
        }
      },
      created() {
          this.loadData()
      },
  
    }
  </script>